// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","logo":"Footer_logo__B7si-","navBar":"Footer_navBar__gf12z","navSocial":"Footer_navSocial__4r7ei"};